import { useEffect, useMemo, useState, useCallback } from 'react';
import { Col, List, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronUp } from 'react-feather';
import envioMailService from '../../services/http/envioEmailService';
import MyEditor from '../../layouts/myEditor/MyEditor';
import sanitizeHtml from '../../helpers/sanitizeHtml';

const MIN_ENVIO_TO_SHOW = 25;

const BodyRemesa = ({ remesa }) => {
  const [envios, setEnvios] = useState([]);
  const [loadingData, setLoadingData] = useState([]);
  const [errorCargaBody, setErrorCargaBody] = useState(false);
  const [showAllEnvios, setShowAllEnvios] = useState(false);

  const decodeContent = (data) => {
    try {
      const decoded = atob(data);

      const parser = new DOMParser();
      const doc = parser.parseFromString(decoded, 'text/html');

      if (doc.body.innerHTML.trim()) {
        setErrorCargaBody(false);
        // Saneamos el HTML del backend antes de volcarlo en TinyMCE: no
        // dependemos solo del saneo interno del editor.
        return sanitizeHtml(doc.body.innerHTML);
      }
    } catch (e) {
      setErrorCargaBody(true);
    }

    setErrorCargaBody(true);
    return '';
  };

  const contenido = useMemo(() => decodeContent(remesa.html), [remesa.html]);

  const fetchEnvios = useCallback(async () => {
    setLoadingData(true);

    try {
      const data = await envioMailService.getEnviosByRemesa({
        headquarter: (remesa.centro ?? '').toUpperCase(),
        idRemesa: remesa.IdRemesa,
      });
      setEnvios(data);
    } catch (error) {
      setEnvios([]);
    } finally {
      setLoadingData(false);
    }
  }, [remesa]);

  useEffect(() => {
    fetchEnvios();
  }, [remesa, fetchEnvios]);

  const enviosToShow = useMemo(
    () => (showAllEnvios ? envios : envios.slice(0, MIN_ENVIO_TO_SHOW)),
    [showAllEnvios, envios],
  );

  if (loadingData) {
    return (
      <Col className="mt-3" md="12">
        Cargando envios de la remesa
      </Col>
    );
  }

  return (
    <Row className="mt-4" md="12">
      <Col>
        <h4>Contenido:</h4>
        {errorCargaBody ? (
          <span className="text-danger">No se ha podido cargar el contenido del email.</span>
        ) : (
          <MyEditor
            initialValue={contenido ?? ''}
            initHeight={700}
            content={contenido ?? ''}
            setContent={() => {}}
            disabled
          />
        )}
      </Col>
      <Col>
        <h4>Destinatarios ({envios.length}):</h4>
        <List>
          {enviosToShow.map((e) => (
            <Row className="m-0">
              <li>
                {e.EmailDestino} ({e.Nombre})
              </li>
            </Row>
          ))}
        </List>
        {envios.length >= MIN_ENVIO_TO_SHOW && (
          <button
            type="button"
            onClick={() => setShowAllEnvios((prev) => !prev)}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
              fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
              border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#6b7280',
              cursor: 'pointer', transition: 'all 0.15s', marginTop: '8px',
            }}
          >
            {showAllEnvios ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
            {showAllEnvios ? 'Ver menos' : 'Ver más'}
          </button>
        )}
      </Col>
    </Row>
  );
};

BodyRemesa.propTypes = {
  remesa: PropTypes.object,
};

export default BodyRemesa;
